import usePageTracking from '../../hooks/usePageTracking';

function GoogleTagManagerTracker() {
  usePageTracking();
}

export default GoogleTagManagerTracker;
